import LoadingScreen from "@/components/LoadingScreen"
import { useAuth } from "@/contexts/AuthContext"
import { router } from "expo-router"
import { ReactNode, useEffect } from "react"

type RequireAuthProps = {
  children: ReactNode
}

export default function RequireAuth({ children }: RequireAuthProps) {
  const auth = useAuth()

  useEffect(() => {
    if (!auth.loading && !auth.session) {
      router.replace("/auth")
    }
  }, [auth.loading, auth.session])

  if (auth.loading) {
    return <LoadingScreen message="Checking your account..." />
  }

  if (!auth.session) {
    return null
  }

  return <>{children}</>
}
